import { createStore } from "vuex";
import utils from "./modules/utils";

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    utils,
  },
});
